module.exports = __webpack_public_path__ + "static/img/video-pass.8127216d.png";